import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { httpInterceptorProviders } from "./header-planter-barrel";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SearchMember } from "./search-member/search-member.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from "ngx-spinner";
import { HelperService } from "./services/helper.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { SocketIoModule, SocketIoConfig } from "ngx-socket-io";
import { env } from '../environments/environment';
import { AuthGuardService } from './auth-service.service';

const socketConfig: SocketIoConfig = { url: env.server, options: {} };

@NgModule({
  declarations: [AppComponent, SearchMember],
  entryComponents: [SearchMember],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ToastrModule.forRoot(),
    SocketIoModule.forRoot(socketConfig),
    BrowserAnimationsModule,
    NgbModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
  ],
  providers: [
    httpInterceptorProviders,
    HelperService,
    DatePipe,
    AuthGuardService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
